export default "__VITE_ASSET__f0d68e9c__"